import React from 'react';
import Backdrop from '../Backdrop/Backdrop';
import './CustomModal.scss';

const customModal = props => {
  const { children } = props;
  return (
    <>
      <Backdrop show />
      <div className='customModal'> {children}</div>
    </>
  );
};

export default customModal;
